import APIClient from './APIClient'
import EndCustomerService from './endCustomers'
import LicenseService from './licenses'
import ConsumersService from './consumers'
import UsersService from './users'
import InvitesService from './userInvites'
import MockInvitesService from './userInvites.mock'
import ResellerService from './resellers'
import ServiceProviderService from './serviceProviders'
import MockEndCustomerService from './endCustomers.mock'
import MockLicenseService from './licenses.mock'
import MockResellerService from './resellers.mock'
import MockUserService from './users.mock'
import MockConsumerService from './consumers.mock'
import MockServiceProviderService from './serviceProviders.mock'
import SearchService from './search'
import MockSearchService from './search.mock'
import GroupService from './group'
import ActivityService from './activity'
import MaintenanceMessageService from './maintenanceMessage'
import config from '../config'

const testing = process.env.USE_TEST_DATA || false
const client = new APIClient(config.apiUrl())

export const endCustomerService = !testing ? new EndCustomerService(client) : new MockEndCustomerService()
export const licensesService = !testing ? new LicenseService(client) : new MockLicenseService()
export const consumersService = !testing ? new ConsumersService(client) : new MockConsumerService()
export const userService = !testing ? new UsersService(client) : new MockUserService()
export const inviteService = !testing ? new InvitesService(client) : new MockInvitesService(client)
export const resellerService = !testing ? new ResellerService(client) : new MockResellerService()
export const serviceProviderService = !testing ? new ServiceProviderService(client) : new MockServiceProviderService()
export const searchService = !testing ? new SearchService(client) : new MockSearchService()
export const groupService = new GroupService(client)
export const activityService = new ActivityService(client)
export const maintenanceMessageService = new MaintenanceMessageService(client)
